import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "regenerator-runtime/runtime.js";
import { baseURLV2 } from "../../axios";
import { convertToEnglishDigit, onUploadProgress as _onUploadProgress } from "../../helpers/Functions";
import ApiService from "./ApiService";

var ProductApiService = /*#__PURE__*/function (_ApiService) {
  _inherits(ProductApiService, _ApiService);

  var _super = _createSuper(ProductApiService);

  function ProductApiService() {
    _classCallCheck(this, ProductApiService);

    return _super.apply(this, arguments);
  }

  _createClass(ProductApiService, [{
    key: "shopSettings",
    value:
    /**
     *
     * @param {number} providerID
     * @returns {Promise}
     */
    function () {
      var _shopSettings = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(providerID) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.get("providers/".concat(providerID, "/settings"), {
                  baseURL: baseURLV2
                });

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", this.throwFetchError(_context.t0));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function shopSettings(_x) {
        return _shopSettings.apply(this, arguments);
      }

      return shopSettings;
    }()
    /**
     *
     * @param {number} id shopId
     * @param {boolean} value 
     * @returns {Promise}
     */

  }, {
    key: "storeOrEditShopSettings",
    value: function () {
      var _storeOrEditShopSettings = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, value, providerId) {
        var formData, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                if (typeof value === 'boolean') {
                  formData.append("value", value ? 1 : 0);
                } else {
                  formData.append("value", value);
                }

                _context2.prev = 2;
                _context2.next = 5;
                return this.axios.post("providers/".concat(providerId, "/settings/").concat(id), formData, {
                  baseURL: baseURLV2
                });

              case 5:
                res = _context2.sent;
                return _context2.abrupt("return", res);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", this.throwFetchError(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 9]]);
      }));

      function storeOrEditShopSettings(_x2, _x3, _x4) {
        return _storeOrEditShopSettings.apply(this, arguments);
      }

      return storeOrEditShopSettings;
    }()
    /**
     *
     * @param {number} providerID
     * @param {number} productID
     * @returns {Promise}
     */

  }, {
    key: "deleteProduct",
    value: function () {
      var _deleteProduct = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(providerID, productID) {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.axios.delete("providers/".concat(providerID, "/items/").concat(productID));

              case 3:
                res = _context3.sent;
                return _context3.abrupt("return", res);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", this.throwFetchError(_context3.t0));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function deleteProduct(_x5, _x6) {
        return _deleteProduct.apply(this, arguments);
      }

      return deleteProduct;
    }()
    /**
     *
     * @param {number} providerID
     * @param {number} categoryID
     * @returns {Promise}
     */

  }, {
    key: "deleteCategory",
    value: function () {
      var _deleteCategory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(providerID, categoryID) {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.axios.delete("providers/".concat(providerID, "/categories/").concat(categoryID));

              case 3:
                res = _context4.sent;
                return _context4.abrupt("return", res);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", this.throwFetchError(_context4.t0));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function deleteCategory(_x7, _x8) {
        return _deleteCategory.apply(this, arguments);
      }

      return deleteCategory;
    }()
    /**
     *
     * @param {number} providerID
     * @param {number} productID
     * @param {JSON} body
     * @returns {Promise}
     */

  }, {
    key: "createOrEditProduct",
    value: function () {
      var _createOrEditProduct = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(providerID) {
        var productID,
            body,
            updateProgress,
            abortController,
            formData,
            extraConfig,
            res,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                productID = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
                body = _args5.length > 2 ? _args5[2] : undefined;
                updateProgress = _args5.length > 3 ? _args5[3] : undefined;
                abortController = _args5.length > 4 ? _args5[4] : undefined;
                formData = new FormData();

                if (body.english_title === null || body.english_title === undefined) {
                  formData.append("english_title", '');
                } else {
                  formData.append("english_title", body.english_title);
                }

                formData.append("available", body.available ? 1 : 0);
                formData.append("featured", body.featured ? 1 : 0);
                formData.append("details", JSON.stringify(JSON.stringify(body.details)));
                if (body.discount) formData.append("discount", convertToEnglishDigit(body.discount));

                if (body.album) {
                  body.album.forEach(function (item) {
                    if (item instanceof File) {
                      formData.append("album[]", item);
                    }
                  });
                }
                /**
                 * Only the first image will upload as thumbnail
                 */


                if (body.thumbnail) {
                  body.thumbnail.forEach(function (item) {
                    if (item instanceof File) {
                      formData.append("thumbnail[]", item);
                    }
                  });
                }

                if (body.level) formData.append("level", convertToEnglishDigit(body.level));
                formData.append("price", body.price ? +convertToEnglishDigit(body.price.splitNumberFormat()) : 0);
                if (body.title) formData.append("title", body.title);
                if (body.unit) formData.append("unit", body.unit);

                if (body.subCategory) {
                  formData.append("category_id", body.subCategory.id);
                } else if (body.category) {
                  formData.append("category_id", body.category.id);
                }

                if (+body.discount > 0 && body.tag_id) formData.append("tag_id", body.tag_id);
                if (productID) formData.append("_method", "PATCH");
                extraConfig = null;

                if (updateProgress || abortController) {
                  extraConfig = {
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    onUploadProgress: function onUploadProgress(progressEvent) {
                      var result = _onUploadProgress === null || _onUploadProgress === void 0 ? void 0 : _onUploadProgress(progressEvent);
                      updateProgress(result);
                    }
                  };
                }

                _context5.prev = 21;
                _context5.next = 24;
                return this.axios.post("providers/".concat(providerID, "/items").concat(productID ? "/".concat(productID) : ""), formData, _objectSpread({
                  headers: {
                    "content-type": "multipart/form-data"
                  }
                }, extraConfig));

              case 24:
                res = _context5.sent;
                return _context5.abrupt("return", res);

              case 28:
                _context5.prev = 28;
                _context5.t0 = _context5["catch"](21);
                return _context5.abrupt("return", this.throwFetchError(_context5.t0));

              case 31:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[21, 28]]);
      }));

      function createOrEditProduct(_x9) {
        return _createOrEditProduct.apply(this, arguments);
      }

      return createOrEditProduct;
    }()
    /**
     *
     * @param {number} providerID
     * @param {number} categoryID
     * @param {JSON} body
     * @returns {Promise}
     */

  }, {
    key: "createOrEditCategory",
    value: function () {
      var _createOrEditCategory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(providerID) {
        var categoryID,
            body,
            parentId,
            updateProgress,
            abortController,
            formData,
            extraConfig,
            res,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                categoryID = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;
                body = _args6.length > 2 ? _args6[2] : undefined;
                parentId = _args6.length > 3 ? _args6[3] : undefined;
                updateProgress = _args6.length > 4 ? _args6[4] : undefined;
                abortController = _args6.length > 5 ? _args6[5] : undefined;
                formData = new FormData();

                if (body.visible === null || body.visible === undefined) {
                  formData.append("visible", 1);
                } else {
                  formData.append("visible", body.visible ? 1 : 0);
                }

                formData.append("available", body.available ? 1 : 0);
                if (body.title) formData.append("title", body.title);
                if (body.level) formData.append("level", convertToEnglishDigit(body.level));
                formData.append("description", body.description || "");

                if (body.thumbnail) {
                  body.thumbnail.forEach(function (item) {
                    if (item instanceof File) {
                      formData.append("thumbnail[]", item);
                    }
                  });
                }

                if (parentId) formData.append("parent_id", parentId);
                if (categoryID) formData.append("_method", "PATCH");
                extraConfig = null;

                if (updateProgress || abortController) {
                  extraConfig = {
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    onUploadProgress: function onUploadProgress(progressEvent) {
                      var result = _onUploadProgress === null || _onUploadProgress === void 0 ? void 0 : _onUploadProgress(progressEvent);
                      updateProgress(result);
                    }
                  };
                }

                _context6.prev = 16;
                _context6.next = 19;
                return this.axios.post("providers/".concat(providerID, "/categories").concat(categoryID ? "/".concat(categoryID) : ""), formData, _objectSpread({
                  headers: {
                    "content-type": "multipart/form-data"
                  }
                }, extraConfig));

              case 19:
                res = _context6.sent;
                return _context6.abrupt("return", res);

              case 23:
                _context6.prev = 23;
                _context6.t0 = _context6["catch"](16);
                return _context6.abrupt("return", this.throwFetchError(_context6.t0));

              case 26:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[16, 23]]);
      }));

      function createOrEditCategory(_x10) {
        return _createOrEditCategory.apply(this, arguments);
      }

      return createOrEditCategory;
    }()
  }]);

  return ProductApiService;
}(ApiService);

var productApiService = new ProductApiService();
export default productApiService;